// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/RelatoriosOS_ProdutividadeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /relatorios/relatorios_os/produtividade (chamado NS 2026-0084).
 *
 * Lista já filtrada pelo filtro global (franquias + período). Os totais são
 * somados no front.
 */
import type { RelatoriosOS_ProdutividadeRow } from './RelatoriosOS_ProdutividadeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type RelatoriosOS_ProdutividadeResponseDados = RelatoriosOS_ProdutividadeRow[];

export type RelatoriosOS_ProdutividadeResponse = ApiResponse<RelatoriosOS_ProdutividadeResponseDados>;

registerResponseContract('RelatoriosOS_ProdutividadeResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:   { type: 'number',  required: true },
      franquia_nome: { type: 'string',  required: true },
      usuario_id:    { type: 'string',  required: true },
      usuario_nome:  { type: 'string',  required: true },
      ordens:        { type: 'number',  required: true },
      valor:         { type: 'number',  required: true },
      ticket_medio:  { type: 'number',  required: true },
      etapas:        { type: 'number',  required: true },
      itens:         { type: 'number',  required: true },
    },
  },
})
